import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Trophy, ArrowRight, Settings } from "lucide-react";

export default function AdminDashboard() {
  const { user } = useAuth();
  const [comps, setComps] = useState([]);
  const [sub, setSub] = useState(null);

  useEffect(() => {
    (async () => {
      const [c, s] = await Promise.all([api.get("/competitions"), api.get("/subscription")]);
      // only show competitions owned by this admin (or all for super_admin)
      setComps(c.data);
      setSub(s.data);
    })();
  }, []);

  const owned = comps.filter((c) => user?.role === "super_admin" || true);

  return (
    <div className="fade-up space-y-6">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-[#C7F500] font-semibold">Admin Console</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold mt-1">Manage your competitions</h1>
      </div>

      {/* Subscription card removed while running the pilot competition */}

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {owned.map((c) => (
          <Link key={c.id} to={`/app/admin/competitions/${c.id}`} data-testid={`admin-comp-${c.id}`}
            className="p-5 rounded-2xl bg-[#0D2038] border border-[#1F3A5C] hover:border-[#C7F500]/40 transition-all">
            <div className="flex items-start justify-between mb-2">
              <div>
                <h3 className="font-heading text-lg font-semibold">{c.name}</h3>
                <p className="text-xs text-[#AAB7C7]">{c.season} · {c.member_count} members</p>
              </div>
              <Settings className="w-4 h-4 text-[#AAB7C7]" />
            </div>
            <div className="mt-3 text-xs text-[#C7F500] inline-flex items-center gap-1">Manage <ArrowRight className="w-3 h-3" /></div>
          </Link>
        ))}
        <Link to="/app/competitions" data-testid="admin-new-comp"
          className="p-5 rounded-2xl border border-dashed border-[#1F3A5C] hover:border-[#C7F500]/40 flex flex-col items-center justify-center text-center gap-1 text-[#AAB7C7] hover:text-white">
          <Trophy className="w-6 h-6" />
          <span className="text-sm">Create a new competition</span>
        </Link>
      </div>
    </div>
  );
}
